import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { KnowledgeBaseLink } from 'common/core/components/SupportLinks'
import { SupportedHelpArticleLanguage, useHelpArticleLink } from 'common/hooks/useHelpArticleLink'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const WaPricingUpdateNotification = () => {
  const helpArticleLink = useHelpArticleLink(KnowledgeBaseLink.WA_PRICING, [
    SupportedHelpArticleLanguage.EN,
    SupportedHelpArticleLanguage.ES,
    SupportedHelpArticleLanguage.PT,
  ])

  const handleShowMore = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.WA_PRICING_UPDATE.LEARN_MORE.CLICK')
  }

  return (
    <>
      <span data-test-id="wa-pricing-update-notification">
        {l.translate(
          'Starting July 1, 2025, Meta will update WhatsApp pricing for different types of conversations and messages.',
        )}
      </span>
      <a
        target="_blank"
        rel="noreferrer"
        className={cx(cm.more, 'm-l-xs')}
        href={helpArticleLink}
        onClick={handleShowMore}
      >
        {l.translate('Learn more')}
      </a>
    </>
  )
}
